import React from 'react'
import i18n from 'i18next'
import Headline from '#components/a/Headline'

function NachweisListeHeaderAusbilder() {
  const headline = 'ausbildungsnachweiseOverview_headline'

  return (
    <div className="nachweisliste__header">
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <Headline importance={1} modifier="section" text={i18n.t(headline)} />
        </div>
      </div>
    </div>
  )
}

export default NachweisListeHeaderAusbilder
